import * as questionResource from '@/modules/question/question.resource';
import * as tagService from '@/modules/tag/tag.service';

export function searchQuestions(searchTerm, pagination = {}) {
  return new Promise((resolve, reject) =>
    questionResource
      .searchQuestions(searchTerm, pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      }).catch(err => reject(err)));
}

export function fetchQuestions(pagination = {}) {
  return new Promise((resolve, reject) =>
    questionResource
      .fetchQuestions(pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchQuestionsAnalytics(payload) {
  return new Promise((resolve, reject) =>
    questionResource
      .fetchQuestionsAnalytics(payload)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(err => reject(err)));
}

export function fetchUserQuestions(user, pagination = {}) {
  return new Promise((resolve, reject) =>
    questionResource
      .fetchUserQuestions(user.id, pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchTagQuestions(tag, pagination = {}) {
  return new Promise((resolve, reject) =>
    questionResource
      .fetchTagQuestions(tag.id, pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      }).catch(err => reject(err)));
}

export function getDepartmentQuestions(departmentId) {
  return new Promise((resolve, reject) =>
    questionResource
      .getDepartmentQuestions(departmentId)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function getQuestion(questionId) {
  return new Promise((resolve, reject) =>
    questionResource
      .getQuestion(questionId)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function getAnswer(answerId) {
  return new Promise((resolve, reject) =>
    questionResource
      .getAnswer(answerId)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function getAnswers(questionId, pagination = {}) {
  return new Promise((resolve, reject) =>
    questionResource
      .getAnswers(questionId, pagination)
      .then(({ data }) => {
        resolve({
          data: {
            articles: data.articles,
          },
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => {
        reject(err);
      }));
}

export function saveQuestion(question) {
  const { content } = question;
  const containsTags = content.match(/#[^#\s]+/gi);
  if (containsTags) {
    return new Promise((resolve, reject) => {
      tagService.saveTagsFromContent(content)
        .then(tags => {
          question.tags = tags;
          getQuestionSaveAction(question)(question)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(err => reject(err));
        })
        .catch(() => {});
    });
  }
  const errors = null;
  return new Promise((resolve, reject) =>
    (errors ? reject(errors) : getQuestionSaveAction(question)(question)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err))));
}

export function removeQuestion(question) {
  return new Promise((resolve, reject) =>
    questionResource
      .removeQuestion(question.id)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      }));
}

function getQuestionSaveAction(question) {
  return question.id ? questionResource.updateQuestion : questionResource.createQuestion;
}
